(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/utils.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var youtubeDomain = "https://www.youtube-nocookie.com";
var ytImgDomain = "https://i.ytimg.com/vi";
function loadVideo(options, callback) {
  if (!options) {
    callback('Options object is required');
    return;
  }
  if (!options.type || options.type !== 'youtube') {
    callback('Unsupported media source type');
    return;
  }
  if (!options.videoId) {
    callback('Missing videoId');
    return;
  }
  var videoId = options.videoId,
    height = options.height,
    width = options.width,
    title = options.title,
    type = options.type,
    name = options.name;
  var videoSrc = "".concat(youtubeDomain, "/embed/").concat(videoId, "?rel=0");
  var thumbnailUrl = "".concat(ytImgDomain, "/").concat(videoId);
  var model = {
    name: name || '100',
    type: type || 'youtube',
    src: videoSrc,
    heightPercent: height && width ? height / width * 100 : undefined,
    videoId: videoId,
    thumbnailUrl: thumbnailUrl,
    title: title || 'Svenska Spel',
    height: height || '1280',
    width: width || '720'
  };
  callback(null, model);
}
if (isServer) {
  module.exports = {
    loadVideo: loadVideo
  };
} else {
  svs.components.youtube_video.utils = {
    loadVideo: loadVideo
  };
}

 })(window);